import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { toggleButtonsArrayButton, setIsScrolled } from './actions'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'mainId', null)

    return {
        disableCiaNewsBtn: state.getIn([
            'ui',
            'workspace',
            'report',
            id,
            'blocks',
            'syntheticIndicators',
            'customData',
            'disableCiaNewsBtn',
        ]),
        addressBlockActive: state.getIn(
            ['ui', 'modules', 'report', 'ribbon', 'reportBlocks', 'data', 'addresses'],
            false
        ),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ toggleButtonsArrayButton, setIsScrolled }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
